<div class="event-resume">
    <div class="er-main">
        <div class="er-title">
            <p class="m-0 ticket-name">
                {{cartLine?.ticket.name}}
                <span *ngIf="cartLine?.quantity && cartLine.quantity > 1" class="qty-badge">(x{{ cartLine.quantity }})</span>
            </p>
            <span class="abono-badge" *ngIf="cartLine?.discount || cartLine?.id_discount">Abono</span>
        </div>
        <div class="seat-info" *ngIf="cartLine.bookings[0]?.seat">
            <div class="seat-info-row seat-info-row--main">
                <fa-icon [icon]="faSeat"></fa-icon>
                <span *ngIf="cartLine.bookings[0]?.seat?.map_section">{{cartLine.bookings[0].seat.map_section?.name}}</span>
            </div>
            <div class="seat-info-row seat-info-row--sub" *ngIf="cartLine.bookings[0]?.seat?.row || cartLine.bookings[0]?.seat?.seat">
                <span *ngIf="cartLine.bookings[0]?.seat?.row">Fila: {{cartLine.bookings[0].seat.row}}</span>
                <span *ngIf="cartLine.bookings[0]?.seat?.row && cartLine.bookings[0]?.seat?.seat">·</span>
                <span *ngIf="cartLine.bookings[0]?.seat?.seat">Butaca: {{cartLine.bookings[0].seat.seat}}</span>
            </div>
        </div>
    </div>
    <div class="er-side">
        <div class="total-price">
            <ng-container *ngIf="cartLine.discount_total > 0; else noDiscount">
                <p class="m-0 price-original-crossed">{{ cartLine.price_original | number: '1.2-2' }} €</p>
                <p class="m-0 price-with-discount">{{ cartLine.price_with_discount | number: '1.2-2' }} €</p>
            </ng-container>
            <ng-template #noDiscount>
                <p class="m-0">{{ (cartLine.price_with_discount ?? (+cartLine.price - +cartLine.fee)) | number: '1.2-2' }} €</p>
            </ng-template>
        </div>
        <button type="button" class="remove-btn" (click)="removeTicketCart()" [disabled]="removing" title="Eliminar">
            <mat-progress-spinner *ngIf="removing" diameter="16" mode="indeterminate" color="accent"></mat-progress-spinner>
            <fa-icon *ngIf="!removing" class="remove-icon" [icon]='faTrashcan'></fa-icon>
        </button>
    </div>
</div>
